// EventBus para la app PWA - Sistema de eventos en tiempo real
// Basado en el EventBus de la app WEB

type EventCallback = (...args: any[]) => void;

class EventBus {
  private events: { [key: string]: EventCallback[] } = {};

  // Suscribirse a un evento
  on(event: string, callback: EventCallback): () => void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);

    // DEBUG: Log específico para suscripciones relacionadas con dispositivo 10697
    if (event === 'device:update' || event === 'device_control_response') {
      console.log(`📝 [EventBus.ts - on] Suscripción a evento "${event}"`, {
        event,
        totalCallbacks: this.events[event].length,
        timestamp: new Date().toISOString()
      });
    }

    // Retornar función para desuscribirse
    return () => {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    };
  }

  // Emitir un evento
  emit(event: string, ...args: any[]): void {
    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        try {
          callback(...args);
        } catch (error) {
          // Error handling sin logs específicos de debugging
        }
      });
    }
  }

  // Desuscribirse de un evento
  off(event: string, callback: EventCallback): void {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    }
  }

  // Limpiar todos los eventos
  clear(): void {
    this.events = {};
  }

  // Obtener lista de eventos activos
  getEvents(): string[] {
    return Object.keys(this.events);
  }
}

// Instancia singleton del EventBus
export const eventBus = new EventBus();
export default eventBus;


